export class IExportDataTask {
  createDateTime: Date;
  createUser: string;
  fileFormat: string;
  fileName: string;
  filePath: string;
  taskStatus: string;
  templateName: string;
}
